import { Component, computed, input } from '@angular/core';

import { environment } from '../../../environments/environment';

/**
 * TEMPORARY development/QA marker. Drop `<app-dev-flag />` onto any section whose content is still
 * static / hardcoded / not yet wired to the admin panel. It renders a small red dot with a tooltip
 * ("Static Section — Not Connected to Admin") so the team can see, at a glance, what still needs
 * admin wiring.
 *
 * Central + globally switchable: every instance renders nothing when `environment.devFlags` is false
 * (already the case in the production environment file), so the whole system disappears before
 * go-live by flipping a single flag — no per-page cleanup required.
 *
 * Usage:
 *   <app-dev-flag />                          // inline dot next to a heading
 *   <app-dev-flag note="Static hero banner" /> // custom tooltip detail
 *   <app-dev-flag position="corner" />         // pin to the top-right of a `position: relative` box
 */
@Component({
  selector: 'app-dev-flag',
  standalone: true,
  templateUrl: './dev-flag.html',
  styleUrl: './dev-flag.scss',
})
export class DevFlag {
  /** Extra context appended to the tooltip, e.g. the field/source that should feed this section. */
  readonly note = input('');
  /** `inline` sits next to text; `corner` pins to the top-right of the nearest positioned ancestor. */
  readonly position = input<'inline' | 'corner'>('inline');

  protected readonly enabled = environment.devFlags;

  protected readonly tooltip = computed(() => {
    const base = 'Static Section — Not Connected to Admin';
    const note = this.note().trim();
    return note ? `${base} · ${note}` : base;
  });
}
